import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { useHistory } from "react-router-dom";

import ShutterbForm from "./ShutterbForm";
import BackButton from "../../shared/components/IconButton/BackButton";

const Shutterb = (props) => {
  const history = useHistory();

  return (
    <>
      <div className="container shutterb-signup">
        <BackButton
          onClick={() => history.goBack()}
          text="go back"
          className="shutterb-signup-back-btn mt-5"
        />
        {!props.isFormSubmitted && (
          <div className="row">
            <div className="col-12 m-auto">
              <div className="d-flex justify-content-center">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <h3 className="mt-3 title">shutterb signup</h3>
                  <p className="pt-3 description">
                    do you love taking pictures or short videos on your
                    smartphone? are you the friend who’s always making sure
                    everything is being captured? if you’re nodding your head
                    yes then we want to hear from you! shutterb is a new kind of
                    photography service that connects event planners with local
                    smartphone photographers. we’re looking for enthusiastic,
                    personable, and driven individuals, who want to get paid for
                    doing what they love using their smartphone!
                  </p>
                  <p className="description">
                    shutterb offers an entrepreneurial environment where you are
                    your own boss. We allow you to set your own schedule and
                    encourage you to not only represent shutterb when on jobs,
                    but also yourself because the higher your ratings the better
                    the perks!
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="row my-2">
          <div className="col-12">
            <ShutterbForm spinnerActions={props.spinnerActions} />
          </div>
        </div>
      </div>
    </>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  isFormSubmitted: state.shutterbAuthentication.isFormSubmitted,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Shutterb));
